import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import PropTypes from 'prop-types';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer';
import DisplaySelectedOffers from '@@viewCommonComponents/displayer/DisplaySelectedOffers';
import DisplayErrorMessage from '@@viewCommonComponents/displayer/DisplayErrorMessage';
import useSouscriptionPricingForm from '../hooks/useSouscriptionPricingForm';
import { Button, Icon, InfoMessage, PageSubtitle, PageTitle } from '@fasstech/middle-design-system';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';
import useRelaisSelfcareSouscriptionPricingMutation from '../hooks/useRelaisSelfcareSouscriptionPricingMutationQuery.js';
import { propOr } from 'ramda';

const SouscriptionPricingForm = ({ project, getMiddleText }) => {
  const [selfcareActivated, setSelfcareActivated] = useState(false);

  const {
    form,
    onSubmit,
    $onPrevClick,
    displayError,
    onSelect,
    selectedModuleCode,
    packs
  } = useSouscriptionPricingForm({
    project
  });

  const { onFormSubmit: commitRelaisSelfcare } = useRelaisSelfcareSouscriptionPricingMutation();

  const relaisSelfcareIsNecessary = propOr(false, 'relaisSelfcareIsNecessary', project);
  const selfcareIsActive = propOr(false, 'selfcareIsActive', project);
  const relaisSelfcareButtonLabel = getMiddleText('PROCESSDEVENTE_RELAIS_SELFCARE_BUTTON_LABEL');
  const relaisSelfcareMessageInfos = getMiddleText('PROCESSDEVENTE_RELAIS_SELFCARE_MESSAGE_INFOS');

  const onRelaisSelfcareClick = () => {
    commitRelaisSelfcare({}, () => {
      setSelfcareActivated(true);
    });
  };

  const { handleSubmit } = form;

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <PageLayout className="overflow-x-hidden">
          <Icon name={'circlePickAProduct'} size={70} />
          <PageTitle>{getMiddleText('CHOIX_PRODUIT_VIEW_TITLE')}</PageTitle>
          <PageSubtitle>{getMiddleText('CHOIX_PRODUIT_VIEW_DESCRIPTION')}</PageSubtitle>
          <DisplaySelectedOffers
            packs={packs}
            enableSelection={true}
            onSelect={onSelect}
            isViewModeCustomer={true}
            selectedModuleCode={selectedModuleCode}
            displayQuoteTable={false}
          />
        </PageLayout>

        <div className={`my-4 ${relaisSelfcareIsNecessary && !selfcareIsActive && !selfcareActivated && isNotNilOrEmpty(relaisSelfcareMessageInfos) ? 'lg:pt-16' : ''}`}>
          {displayError && (
            <DisplayErrorMessage
              text={'Veuillez saisir au moins une offre pour poursuivre le parcours'}
            />
          )}

          <ButtonContainer
            $onPreviousButtonClick={$onPrevClick}
            displayPreviousButton={!selfcareIsActive && !selfcareActivated}
            nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_SUBSCRIBE_BUTTON_LABEL')}
            displayResumeButton
            errorTooltipMessage={getMiddleText(
              'GENERAL_COMMON_TEXTS_TAB_ACTION_ERROR_WARNING_DESCRIPTION'
            )}
            getMiddleText={getMiddleText}
          >
            {relaisSelfcareIsNecessary && !selfcareIsActive && !selfcareActivated && (
              <div className={'relative flex flex-col items-center gap-2'}>
                {isNotNilOrEmpty(relaisSelfcareMessageInfos) && (
                  <div className={'w-full lg:absolute lg:bottom-full lg:mb-2'}>
                    <InfoMessage className="text-[10px]" iconName="lightbulb">
                      {relaisSelfcareMessageInfos}
                    </InfoMessage>
                  </div>
                )}
                <Button
                  variant="secondary"
                  className={'font-bold w-full whitespace-nowrap'}
                  onClick={onRelaisSelfcareClick}
                  disabled={selfcareActivated}
                >
                  {relaisSelfcareButtonLabel}
                </Button>
              </div>
            )}
          </ButtonContainer>
        </div>
      </form>
    </FormProvider>
  );
};

SouscriptionPricingForm.propTypes = {
  processHandlers: PropTypes.object
};

export default SouscriptionPricingForm;
